if (!customElements.get('card-product')) {
    class CardProduct extends HTMLElement {
      connectedCallback() {
        if (this.dataset.rsCardReady === 'true') return;
        this.dataset.rsCardReady = 'true';

        this.images = Array.from(this.querySelectorAll('[data-images] img'));
        this.swatches = this.querySelector('[data-swatches]');
        this.price = this.querySelector('.js-price');
        this.bundleButton = this.querySelector('.js-bundle-pick');

        this.swatches?.addEventListener('change', (e) => {
          const target = e.target;

          this.updateImage(target.dataset.variantId);
          this.updatePrice(target.dataset.price);
          this.updateBadges(target);
          this.updateButton(
            target.dataset.variantId,
            target.dataset.originalImage,
            target.dataset.isAvailable === 'true',
            target.dataset.varBtnTitle
          );
        });


        const checked = this.swatches?.querySelector('input:checked');
        if (checked) {
          this.updateBadges(checked);
          this.updateButton(
            checked.dataset.variantId,
            checked.dataset.originalImage,
            checked.dataset.isAvailable === 'true',
            checked.dataset.varBtnTitle
          );
        }
      }

      updatePrice(price) {
        if (price) this.price.innerHTML = price;
      }

      parseBadgeList(value) {
        try {
          const badges = JSON.parse(value || '[]');
          return Array.isArray(badges) ? badges.filter(Boolean) : [];
        } catch (e) {
          return [];
        }
      }

      parseDataMap(value) {
        try {
          const map = JSON.parse(value || '{}');
          return map && typeof map === 'object' ? map : {};
        } catch (e) {
          return {};
        }
      }

      updateLowStockBadge(container, variantId) {
        const map = this.parseDataMap(container.dataset.lowStockMap);
        const shouldShow = Boolean(variantId && map[variantId]);
        let lowStock = container.querySelector('.product-card__badge--low-stock');

        if (shouldShow) {
          if (!lowStock) {
            lowStock = document.createElement('span');
            lowStock.className = 'product-card__badge product-card__badge--low-stock';
            lowStock.textContent = container.dataset.lowStockText || 'LOW STOCK';
            container.appendChild(lowStock);
          }
        } else if (lowStock) {
          lowStock.remove();
        }
      }

      updateBadges(target) {
        let container = this.querySelector('[data-rs-card-badges], .product-card__badges:not(.product-card__badges--right)');
        const images = this.querySelector('[data-images]');
        if (!container && images) {
          container = document.createElement('div');
          container.className = 'product-card__badges';
          container.setAttribute('data-rs-card-badges', '');
          images.prepend(container);
        }
        if (!container) return;

        const variantId = target && target.dataset ? target.dataset.variantId : '';
        const map = this.parseDataMap(container.dataset.variantBadgeMap);
        let badges = this.parseBadgeList(target && target.dataset ? target.dataset.variantBadges : '');

        if (!badges.length && variantId && Array.isArray(map[variantId])) {
          badges = map[variantId].filter(Boolean);
        }
        if (!badges.length) {
          badges = this.parseBadgeList(container.dataset.productBadges);
        }

        this.updateLowStockBadge(container, variantId);
        container.querySelectorAll('.product-card__badge:not(.product-card__badge--low-stock)').forEach((el) => el.remove());
        const lowStock = container.querySelector('.product-card__badge--low-stock');
        badges.forEach((badge) => {
          const span = document.createElement('span');
          span.className = 'product-card__badge';
          span.textContent = badge;
          container.insertBefore(span, lowStock);
        });
      }

      updateImage(variantId) {
        if (this.images.length === 0) return;

        const visibleImage = this.querySelector('[data-images] img:not(.hidden)');
        let newVisibleImage = this.images.find(
          (image) => image.dataset.variantId === variantId
        );

        if (!newVisibleImage) newVisibleImage = this.images[0];

        visibleImage?.classList.add('hidden');
        newVisibleImage.classList.remove('hidden');
      }

      updateButton(variantId, originalImage, isAvailable, varOverride) {
        if (!this.bundleButton) return;

        if (variantId) this.bundleButton.dataset.variantId = variantId;
        if (originalImage) this.bundleButton.dataset.image = originalImage;

        const addText = varOverride || '+ Add to bundle';

        if (!isAvailable) {
          this.bundleButton.textContent = 'Sold out';
          this.bundleButton.dataset.btntext = 'Sold out';
          this.bundleButton.disabled = true;
          this.bundleButton.setAttribute('aria-disabled', 'true');
        } else {
          this.bundleButton.textContent = addText;
          this.bundleButton.dataset.btntext = addText;
          this.bundleButton.disabled = false;
          this.bundleButton.removeAttribute('aria-disabled');
        }
      }
    }

    customElements.define('card-product', CardProduct);
  }
